import React from 'react';

export const TrialPlanIcon = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.1272 9.70801C4.1272 9.36283 4.40702 9.08301 4.7522 9.08301H15.2479C15.5931 9.08301 15.8729 9.36283 15.8729 9.70801V16.9971C15.8729 17.3423 15.5931 17.6221 15.2479 17.6221H4.7522C4.40702 17.6221 4.1272 17.3423 4.1272 16.9971V9.70801ZM5.3772 10.333V16.3721H14.6229V10.333H5.3772Z"
      fill={color || '#00875A'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.78711 9.70801C7.78711 9.36283 8.06693 9.08301 8.41211 9.08301H11.588C11.9332 9.08301 12.213 9.36283 12.213 9.70801V16.9971C12.213 17.3423 11.9332 17.6221 11.588 17.6221H8.41211C8.06693 17.6221 7.78711 17.3423 7.78711 16.9971V9.70801ZM9.03711 10.333V16.3721H10.963V10.333H9.03711Z"
      fill={color || '#00875A'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20996 9.70801C3.20996 10.0532 3.48978 10.333 3.83496 10.333H16.1649C16.5101 10.333 16.7899 10.0532 16.7899 9.70801V6.69872C16.7899 6.35354 16.5101 6.07372 16.1649 6.07372H3.83496C3.48978 6.07372 3.20996 6.35354 3.20996 6.69872V9.70801ZM4.45996 9.08301V7.32372H15.5399V9.08301H4.45996Z"
      fill={color || '#00875A'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.80679 3.62793C7.642 3.6276 7.47895 3.6894 7.33342 3.841C7.1274 4.0556 7.0598 4.26614 7.06363 4.45431C7.06764 4.65097 7.15182 4.88651 7.36137 5.12889C7.71012 5.53227 8.37928 5.91223 9.34203 6.03362C9.22583 4.90767 8.82082 4.22199 8.42847 3.89176C8.19727 3.69717 7.97809 3.62827 7.80679 3.62793ZM9.23339 2.93541C10.0679 3.63782 10.625 4.93553 10.625 6.69873L10.625 7.32373H9.99995C8.41874 7.32373 7.13578 6.77921 6.41578 5.94641C6.05365 5.52756 5.82492 5.02115 5.81389 4.47977C5.80269 3.92992 6.01792 3.40633 6.43169 2.97533C6.80572 2.58571 7.29214 2.3769 7.80928 2.37793C8.31991 2.37895 8.81513 2.58337 9.23339 2.93541Z"
      fill={color || '#00875A'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8081 4.27722C11.913 4.27701 12.019 4.31504 12.1189 4.4191C12.2704 4.57699 12.3132 4.72305 12.3107 4.8464C12.308 4.97823 12.2513 5.14859 12.092 5.33289C11.8422 5.62175 11.3645 5.90693 10.6682 6.02135C10.7793 5.19852 11.0857 4.70493 11.3661 4.46891C11.5402 4.32233 11.6967 4.27744 11.8081 4.27722ZM10.5612 3.51256C9.84073 4.11894 9.37498 5.22459 9.37498 6.69876L9.37498 7.32376H9.99998C11.3264 7.32376 12.418 6.86705 13.0376 6.15042C13.3495 5.78964 13.5507 5.3484 13.5604 4.87186C13.5703 4.38683 13.3799 3.92772 13.0206 3.55343C12.6922 3.21135 12.2628 3.02631 11.8056 3.02723C11.3549 3.02812 10.9224 3.20854 10.5612 3.51256Z"
      fill={color || '#00875A'}
    />
  </svg>
);
